<template>
  <section class="flex flex-col gap-2 text-sm">
    <div class="line">
      <i class="fa-solid fa-calendar-day"></i>
      <b>Data:</b>
      <span>
        {{ formatDate(procedure.executed_at, 'DD/MM/YYYY HH:mm') }}
      </span>
    </div>
    <div v-if="procedure.current_organization" class="line">
      <i class="fa-solid fa-building"></i>
      <b>Setor:</b>
      <span>
        {{ procedure.current_organization.name }}
      </span>
    </div>
    <div v-if="procedure.executor" class="line">
      <i class="fa-solid fa-user-gear"></i>
      <b>Executor:</b>
      <span>
        {{ procedure.executor.person.name }}
      </span>
    </div>
    <div v-if="procedure.owner" class="line">
      <i class="fa-solid fa-user-shield"></i>
      <b>Responsável:</b>
      <span>
        {{ procedure.owner.name }}
      </span>
    </div>
    <div class="line">
      <i class="fa-solid fa-user-pen"></i>
      <b>Último(a) Atualizador(a):</b>
      <span>
        {{ procedure.updated_by.name ?? null }}
      </span>
    </div>
    <div class="line">
      <i class="fa-solid fa-calendar-day"></i>
      <b>Última Atualização:</b>
      <span>
        {{ formatDate(procedure.updated_at, 'DD/MM/YYYY HH:mm') }}
      </span>
    </div>
    <div v-if="procedure.observation" class="grid grid-cols-[auto_1fr] gap-1 items-baseline">
      <i class="fa-solid fa-circle-info"></i>
      <span class="text-justify">
        <b class="mr-1">Descrição:</b>
        <RpmReadMore :text="procedure.observation"></RpmReadMore>
      </span>
    </div>
  </section>

  <section v-if="procedure.questionnaire" v-for="(group, groupIdx) in procedure.questionnaire.groups" class="flex flex-col gap-4 mt-2">
    <span class="font-bold text-lg">
      {{ group.label }}
    </span>
    <section class="flex flex-col gap-x-3 gap-y-5 px-2">
      <div v-for="(question, questionIdx) in group.questions" class="flex flex-col gap-1">
        <span class="font-semibold">
          {{ question.label }}
        </span>
        <Details
          :id="question.id"
          :procedure="procedure"
          :original="procedure.source_procedure.questionnaire?.groups[groupIdx].questions[questionIdx]"
          :value="question.value"
          :type="question.field_type.label"
          v-model="form[question.id]"
          @deleted="$emit('deleted', $event)"
          @confirm="formatForm"
        />
      </div>
    </section>
  </section>
</template>


<script>

import {formatDate} from "#functions/formatter.js";

import RpmReadMore from '#components/RpmReadMore';

import Details from '#views/questionnaire/details';

export default {
  name: "ExecutedCase",
  emits: ["deleted", "confirm"],
  components: {
    Details,
    RpmReadMore
  },
  data(){
    return {
      form: {}
    }
  },
  props: {
    procedure: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatForm(key){
      this.$emit('confirm', {
        question_id : key,
        value: this.form[key]
      });
    },
    formatDate(...params){
      return formatDate(...params);
    },
  },
};
</script>
